import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { RefAnswer, Patient } from "@/src/data/allTypes";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import { Card } from "@/src/components/cards";

export function AntecedentsCard({
  antecedent,
  patient,
  onClick,
}: {
  antecedent: RefAnswer;
  patient: Patient;
  onClick: () => Promise<void>;
}) {
  return (
    <Card
      color="blue"
      className="patient_antecedent"
      onClick={async () => {
        await onClick();
      }}
    >
      <div className="main-color bold capitalize">
        {antecedent.reference?.name}
      </div>
      <div className="c1 gap10">
        {antecedent.fieldAnswers?.length != 0 && (
          <FieldAnswersList
            patient={patient}
            reference={antecedent.reference}
            answers={antecedent.fieldAnswers}
          ></FieldAnswersList>
        )}
        {antecedent.notes != null && <div>{antecedent.notes || ""}</div>}
        {/* <div>{antecedent._date || ""}</div> */}
      </div>
    </Card>
  );
}
